export const accentColor = '#fd845f';
export const BASIC_COLOR_SET = [
  '#3054a8',
  '#56adf1',
  '#b092d2',
  '#fd845f',
  '#86c285',
  '#569f90',
  '#fa8d8d',
];
